<p class="input-info-box">
    <svg [attr.height]="svgHeight" style="float: left;" width="15">
        <polyline [attr.points]="svgPosition" style="fill: none; stroke: #5b5a59; stroke-width:1"/>
    </svg>
    <span [innerHtml]="text | safeHtml"></span>
</p>
